"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entityFeedRouteComponent = exports.EntityFeedRoute = exports.EntityFeedRouteDefaultProps = exports.PLATFORM_ACTIVITY_QUERY = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var lodash_1 = require("lodash");
var use_app_section_definition_1 = require("../../hooks/use-app-section-definition");
var use_lang_1 = require("../../hooks/use-lang");
var entity_feed_1 = require("./entity-feed");
var seo_1 = require("../elements/seo");
var icon_button_1 = require("../elements/icon-button");
var wait_message_1 = require("../elements/wait-message");
var client_1 = require("@apollo/client");
var react_infinite_scroll_hook_1 = __importDefault(require("react-infinite-scroll-hook"));
var loading_layout_1 = require("../elements/loading-layout");
var app_screen_layout_1 = require("../app/app-screen-layout");
var tabs_1 = require("../elements/tabs");
var tab_1 = require("../elements/tab");
var icons_1 = require("../icons");
var graphql_1 = require("../../utils/graphql");
var menu_button_1 = require("../elements/menu-button");
exports.PLATFORM_ACTIVITY_QUERY = (0, graphql_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query PlatformActivityFeed($input: PlatformActivityInput) {\n    platformActivity(input: $input) {\n      meta {\n        count\n        total\n      }\n      results {\n        id action date\n        person { ...EntityValueFields }\n        comments {\n          id name slug created isWriteable description { id text html }\n          createdBy { ...EntityValueFields }\n          replies { id name slug isWriteable created description { id text html }\n            createdBy { ...EntityValueFields }\n          }\n        }\n        entity {\n          ...EntityValueFields\n          isPublished\n          isDraft\n          _entityTypeName\n        }\n      }\n    }\n  }\n"], ["\n  query PlatformActivityFeed($input: PlatformActivityInput) {\n    platformActivity(input: $input) {\n      meta {\n        count\n        total\n      }\n      results {\n        id action date\n        person { ...EntityValueFields }\n        comments {\n          id name slug created isWriteable description { id text html }\n          createdBy { ...EntityValueFields }\n          replies { id name slug isWriteable created description { id text html }\n            createdBy { ...EntityValueFields }\n          }\n        }\n        entity {\n          ...EntityValueFields\n          isPublished\n          isDraft\n          _entityTypeName\n        }\n      }\n    }\n  }\n"])));
exports.EntityFeedRouteDefaultProps = {
  entityTypeNames: []
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var EntityFeedStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: ", " ", " ", " ", ";\n    padding-left: 4px;\n  "], ["\n    margin: ", " ", " ", " ", ";\n    padding-left: 4px;\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(0), theme_1.theme.UNIT(4), theme_1.theme.UNIT(0)),
  desktop: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", ";\n    margin: ", " ", " ", " ", ";\n  "], ["\n    ", ";\n    margin: ", " ", " ", " ", ";\n  "])), theme_1.theme.V_DOT_BG(), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4), theme_1.theme.UNIT(8))
});
var CreateButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    text-transform: none;\n  "], ["\n    text-transform: none;\n  "])))
});
var InfiniteContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "])))
});
var WaitMessageContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    max-width: ", ";\n    margin: 0 auto;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  "], ["\n    max-width: ", ";\n    margin: 0 auto;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  "])), theme_1.theme.MAX('content-width'))
});
var WaitMessageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(25)),
  tablet: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    margin-top: 0;\n  "], ["\n    margin-top: 0;\n  "])))
});
var LoadingLayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var TabsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
var TabStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  "], ["\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    margin-top: 4px;\n  "], ["\n    margin-top: 4px;\n  "])))
});
var MenuButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  EntityFeed: (0, styled_components_1.default)(entity_feed_1.EntityFeed)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), EntityFeedStyles),
  InfiniteContainer: styled_components_1.default.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), InfiniteContainerStyles),
  CreateButton: (0, styled_components_1.default)(icon_button_1.CreateIconButton)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), CreateButtonStyles),
  MenuButton: (0, styled_components_1.default)(menu_button_1.MenuButton)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), MenuButtonStyles),
  Tabs: (0, styled_components_1.default)(tabs_1.Tabs)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), TabsStyles),
  Tab: (0, styled_components_1.default)(tab_1.Tab)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), TabStyles),
  WaitMessageContainer: styled_components_1.default.div(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), WaitMessageContainerStyles),
  WaitMessage: (0, styled_components_1.default)(wait_message_1.WaitMessage)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), WaitMessageStyles),
  LoadingLayout: (0, styled_components_1.default)(loading_layout_1.LoadingLayout)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), LoadingLayoutStyles)
};
var fetchMoreParams = function (variables, items, resultKey) {
  return {
    /*
    NB: using items.length in `skip` here advances the cursor, as the
    length continues to grow as more results are fetched
    */
    variables: __assign(__assign({}, variables), {
      input: __assign(__assign({}, variables && variables.input || {}), {
        skip: items.length
      })
    }),
    updateQuery: function (prev, _a) {
      var _b;
      var fetchMoreResult = _a.fetchMoreResult;
      if (!fetchMoreResult) return prev;
      var resultPrev = (0, lodash_1.get)(prev, resultKey, {
        results: []
      });
      var result = (0, lodash_1.get)(fetchMoreResult, resultKey, {
        results: []
      });
      var newResult = (_b = {}, _b[resultKey] = __assign(__assign({}, resultPrev), {
        results: __spreadArray(__spreadArray([], __read(resultPrev.results), false), __read(result.results), false)
      }), _b);
      return newResult;
    }
  };
};
var EntityFeedRoute = function (props) {
  var className = props.className,
    entityTypeNames = props.entityTypeNames;
  var appSection = (0, use_app_section_definition_1.useAppSectionDefinition)().appSection;
  var t = (0, use_lang_1.useLang)();
  var variables = {
    input: {
      limit: 10,
      entityTypeNames: entityTypeNames
    }
  };
  var _a = (0, client_1.useQuery)(exports.PLATFORM_ACTIVITY_QUERY, {
      notifyOnNetworkStatusChange: true,
      variables: variables
    }),
    data = _a.data,
    error = _a.error,
    loading = _a.loading,
    fetchMore = _a.fetchMore;
  var items = data && data.platformActivity && data.platformActivity.results || [];
  var meta = data && data.platformActivity && data.platformActivity.meta || {
    count: 0,
    total: 0
  };
  var hasNextPage = meta.total > items.length;
  var onLoadMore = function () {
    fetchMore(fetchMoreParams(variables, items, 'platformActivity'));
  };
  var _b = __read((0, react_infinite_scroll_hook_1.default)({
      loading: loading,
      hasNextPage: hasNextPage,
      onLoadMore: onLoadMore,
      disabled: false,
      rootMargin: '0px 0px 100px 0px'
    }), 1),
    sentryRef = _b[0];
  return react_1.default.createElement(app_screen_layout_1.AppScreenLayout, {
    className: className,
    header: react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(My.Tabs, {
      items: [react_1.default.createElement(My.Tab, {
        to: '/latest',
        icon: icons_1.Icons.Feed,
        isCurrent: true
      }, t('Latest Activity'))]
    }), react_1.default.createElement(My.MenuButton, {
      icon: icons_1.Icons.Feed
    }, t('Latest Activity')))
  }, react_1.default.createElement(seo_1.Seo, {
    includeOpenGraph: true,
    title: appSection.label
  }), react_1.default.createElement(My.InfiniteContainer, null, react_1.default.createElement(My.EntityFeed, {
    items: items
  }), (loading || hasNextPage) && !(!loading && items.length === 0) && react_1.default.createElement("div", {
    ref: sentryRef
  }, react_1.default.createElement(My.WaitMessage, {
    loading: loading
  }, t('Loading. Please wait...')))));
};
exports.EntityFeedRoute = EntityFeedRoute;
var entityFeedRouteComponent = function (entityTypeNames) {
  return function (props) {
    return react_1.default.createElement(exports.EntityFeedRoute, __assign({
      entityTypeNames: entityTypeNames
    }, props));
  };
};
exports.entityFeedRouteComponent = entityFeedRouteComponent;
exports.EntityFeedRoute.defaultProps = exports.EntityFeedRouteDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26;